  document.addEventListener("DOMContentLoaded", function () {
    const cntLists = document.querySelectorAll(".cntList");
    const scBlocks = document.querySelectorAll(".scBlk");

    cntLists.forEach((listItem) => {
      listItem.addEventListener("click", () => {
        const targetType = listItem.getAttribute("data-htType");

        // cntList の active 切り替え
        cntLists.forEach((item) => item.classList.remove("active"));
        listItem.classList.add("active");

        // scBlk の sc-active 切り替え（フェード反映）
        scBlocks.forEach((blk) => {
          blk.classList.toggle("sc-active", blk.getAttribute("data-htType") === targetType);
        });
      });
    });
  });